export let LOGOUT = "login/LOGOUT";
export const CHANGE_LOGIN = 'login/CHANGE_LOGIN';
